<template>
  <div class="app-options-select">
    <slot name="txtHeader"><h2>Optionen buchen</h2></slot>
    <div class="txt-before"><slot name="txtBefore">Wählen Sie hier Ihre Option: </slot></div>
    <div class="options-wrapper">
      <label :data-disabled="isDisabled(option)" :for="'option-'+ option.id "
             v-for="option in options" :key="option.id" class="option-box"
             :id="option.id">
        <div class="option">
          <div class="option-main-box">
            <div class="image">
              <img v-if="option.icon" :src="option.icon">
            </div>
            <div class="checkbox-label">
              <span v-html="option.name"></span>
              <span v-if="option.extraHtml" v-html="option.extraHtml"></span>
              <div class="txt-no-duration option-info" v-if="!option.duration || !option.duration.amount">
                <slot name="txtNoDuration">Gültig bis: unbefristet</slot>
              </div>
              <div class="option-info">
                <p v-if="option.desc" v-html="option.desc"></p>
              </div>
            </div>
          </div>
        </div>
        <div class="info">
          <div class="info-box">
          <span class="option-info" v-if="option.price !== 0 && option.duration && option.duration.amount">
            {{ centsToEuros(option.price) }} / {{option.duration.amount}} {{ durationUnit(option.duration.unit) }}
          </span>
          <span class="txt-for-free option-info" v-if="option.price === 0">
            <slot name="txtForFree">kostenlos</slot>
          </span>
          <div v-if="option.info"
               v-b-tooltip.hover.bottom="{customClass: 'wide-tooltip'}"
               :title="option.info"
               class="info-bubble">
            <div class="hover-toggle"></div>
          </div>
          </div>
        </div>
        <div class="input-checkbox">
          <input type="checkbox"
                 :id="'option-' + option.id"
                 :value="option"
                 v-model="mutableSelectedOptions"
                 :name="'option-' + option.id"
                 class="select-box"
                 @change="selectOption(option)">
        </div>
      </label>
      <BalanceInfo v-if="isBalanceSet">
        <template #txtBeforeFormattedBalance><slot name="txtBeforeFormattedBalance"></slot></template>
      </BalanceInfo>
      <div class="sum-wrapper">
        <slot name="txtSum">Kosten für Ihre Auswahl:</slot>
        <span class="sum"> {{ centsToEuros(totalSum) }} </span>
      </div>
      <Stepper
        :show-prev="true"
        @prev="prev"
        @next="next"
        :disabledNext="disabledNext"
        :loading-next="loading"
      >
        <template #btnNext><slot name="btnNext"></slot></template>
      </Stepper>
    </div>
  </div>
</template>

<script>
import durationUnit from '../../../../../mixins/durationUnit'
import Stepper from '../../../../generic/Stepper.vue'
import BalanceInfo from '../../Balance/BalanceInfo.vue'
import processSteps from '@/mixins/processSteps'
import { stepName as summaryStep } from './Summary.vue'
import { stepName as viewStep } from './View.vue'

export const stepName = 'selectBook'
export default {
  name: 'OptionsSelect',
  components: { BalanceInfo, Stepper },
  computed: {
    isBalanceSet () {
      return this.balance !== false
    },
    disabledNext: function () {
      return this.mutableSelectedOptions.length === 0
    },
    totalSum: function () {
      let sum = 0
      this.mutableSelectedOptions.forEach(function (option) {
        sum = sum + option.price
      })
      return sum
    }
  },
  data () {
    return {
      mutableSelectedOptions: this.selectedOptions
    }
  },
  props: {
    options: {
      type: Array
    },
    selectedOptions: {
      type: Array,
      default: () => []
    },
    balance: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    isDisabled (option) {
      this.$emit('is-disabled', option)
    },
    selectOption (option) {
      this.$emit('update:mutableSelectedOptions', this.mutableSelectedOptions)
      this.$emit('select-option', option)
    },
    centsToEuros (value) {
      return this.$config.calendar.formatter.currencyFormatter.format(parseInt(value) / 100)
    },
    next () {
      this.$emit('update-options', this.mutableSelectedOptions)
      this.$emit('update-step', this.nextStep)
    },
    prev () {
      this.$emit('update-step', this.previousStep)
    }
  },
  mixins: [
    durationUnit,
    processSteps(stepName, viewStep, summaryStep)
  ]
}
</script>
